import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { ENV } from '@app/env';
import { IService, IServiceGroup } from 'models/services.model';

@Injectable()
export class ServiceProvider {

  constructor(
    private afDatabase: AngularFireDatabase,
  ) { }

  public getServices() {
    return this.afDatabase.list<IService>(`/Clients/${ENV.client}/Services`, ref => ref.orderByChild('state').equalTo(true))
      .valueChanges();
  }

  public getGroups() {
    return this.afDatabase.list<IServiceGroup>(`/Clients/${ENV.client}/ServiceGroups`, ref => ref.orderByChild('state').equalTo(true))
      .valueChanges();
  }

  public addServiceToShoppingCart(uid: string, service: any) {
    return this.afDatabase.object(`/Clients/${ENV.client}/UserServicesShoppingCart/${uid}`).set(service);
  }

  public getBeneficiaries(uid: string) {
    return this.afDatabase.list<any>(`/Clients/${ENV.client}/Users/${uid}/UsersBeneficiaries`).valueChanges();
  }

  public getTitulars() {
    return this.afDatabase.list<any>(`/Clients/${ENV.client}/Users`, ref => ref.orderByChild('isTitular').equalTo(true)).valueChanges();
  }

  public getServiceShoppingCart(uid: string) {
    return this.afDatabase.object(`/Clients/${ENV.client}/UserServicesShoppingCart/${uid}`).valueChanges();
  }
  
  public getServiceShoppingCartSnap(uid: string) {
    return this.afDatabase.object(`/Clients/${ENV.client}/UserServicesShoppingCart/${uid}`).query.once('value');
  }

  public addFormToService(userId: string, sale_form_user_data: any, serviceId: string): Promise<any> {
    return this.afDatabase.object(`/Clients/${ENV.client}/UserServicesShoppingCart/${userId}/services/${serviceId}`)
      .update({ sale_form_user_data });
  }

  public getServiceById(id: string) {
    return this.afDatabase.object(`/Clients/${ENV.client}/Services/${id}`).valueChanges();
  }

  public getServiceSnapById(id: string) {
    return this.afDatabase.object(`/Clients/${ENV.client}/Services/${id}`).query.once('value').then(snap => snap.val());
  }

  public getAdditionalServiceById(id: string) {
    return this.afDatabase.object(`/Clients/${ENV.client}/AdditionalServices/${id}`).valueChanges();
  }

  public setServicesShoppingCartServices(services: any[], reserve: string, uid: string) {
    return this.afDatabase.object(
      `/Clients/${ENV.client}/UserReserveShoppingCart/${uid}/reserves/${reserve}/services`
    ).set(services).then(() => this.dispatchServicesShoppingCartCalc(uid));
  }

  public dispatchServicesShoppingCartCalc(uid: string) {
    return this.afDatabase.object(
      `/Clients/${ENV.client}/UserServicesShoppingCart/${uid}/isLoad`
    ).set(true);
  }

}



// WEBPACK FOOTER //
// ./src/providers/services.ts